import * as ko from "knockout";
import * as _ from "underscore";

// Helpers
import "knockout.validation";
import "knockoutCustomBindings";

export interface IAlertValidation {
    Value: KnockoutObservable<any> | KnockoutObservableArray<any>;          // Required Property
}

export default class AlertValidation {
    value: KnockoutObservable<any> | KnockoutObservableArray<any>;

    displayContainer: KnockoutComputed<boolean>;

    constructor(params: IAlertValidation) {
        // Provided Component Properties
        this.value = params.Value;

        // Initialisation Methods
        this.computedMethods();
    }

    private computedMethods(): void {
        this.displayContainer = ko.pureComputed(() => {
            return this.value.isModified && this.value.isModified() && !this.value.isValid();
        });
    };
}

const componentName = "alert-validation";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: AlertValidation,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertValidation/${componentName}.html` }
});
const basicAlertValidationComponentName = "basic-alert-validation";
ko.components.unregister(basicAlertValidationComponentName);
ko.components.register(basicAlertValidationComponentName, {
    viewModel: AlertValidation,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertValidation/${basicAlertValidationComponentName}.html` }
});